import { render } from "./OnlineSeminar.vue?vue&type=template&id=3a777e0a&scoped=true"
import script from "./OnlineSeminar.vue?vue&type=script&lang=js"
export * from "./OnlineSeminar.vue?vue&type=script&lang=js"

import "./OnlineSeminar.vue?vue&type=style&index=0&id=3a777e0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a777e0a"]])

export default __exports__